import { translationsAPI } from '@/providers/apis/translations/translations';
import { Vue, Component, Prop } from 'vue-property-decorator';
import VueMultiSelect from 'vue-multiselect';
import { appConfigService } from '@/providers/services/app/app-config';
import JsonCSV from 'vue-json-csv';
import papaparse from 'papaparse';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'translations-list',
    components: {
        'vue-multi-select': VueMultiSelect,
        'download-csv': JsonCSV,
    },
})

export default class TranslationsList extends Vue {

    // ---------------------------------------------------------------
    // Properties

    public translationList: { [key: string]: string } = {};

    public filteredList = [];

    public editTranslations: any = [];

    public searchTerms: string = '';

    public get languageList() {
        return appConfigService.getLanguages();
    }

    public selectedLang: any = this.languageList[0];

    public isLoading: boolean = false;

    public get appId() {
        return appConfigService.getAppId();
    }

    public jsonKeysList: any = [];

    public transfields: any = [
        {
            label: 'SL. No',
            key: 'id',
            thClass: 'sl-width ',
        },
        {
            label: 'Guidelines',
            key: 'text',
        },
    ];


    public transGuidelines: any = [
        {
            id: 1,
            text: `Don't Translate the words which are mentioned within "{{}}".`,
            ex: [
                `Eg :English : Please select the correct image(s), and click "{{action}}".`,
                `Eg: Kannada : ದಯವಿಟ್ಟು ಸರಿಯಾದ ಚಿತ್ರ (ಗಳು) ಆಯ್ಕೆ ಮಾಡಿ, ಮತ್ತು '{{action}}' ಕ್ಲಿಕ್ ಮಾಡಿ.`,
            ],
        },
        {
            id: 2,
            text: `Retain all HTML tags as is. (In case if any question, better to contact gooru team)`,
            ex: [
                `Eg: English : You haven\'t created <span>{{type}}</span> yet. Go on, be bold.`,
                `Eg: Kannada : ನೀವು ಇನ್ನೂ <span> {{type}} </span> ಅನ್ನು ರಚಿಸಲಿಲ್ಲ. ಮುಂದುವರಿಯಿರಿ, ದಪ್ಪವಾಗಿರಿ.`,
            ],
        },
            // {
            //     id: 3,
            //     text: `Enter/update the new translated text in Column B
            // ("Translation Language Label Value(<language>)") in respective language sheets.`,
            //     ex: [],
            // },
        {
            id: 3,
            text: `Translate full english sentence for language. Please don't cut short without intimation.`,
            ex: [],
        },
            // {
            //     id: 5,
            //     text: `Don't change/edit English Text (Column A).`,
            //     ex: [],
            // },
        {
            id: 5,
            text: `Please go through the Product before starting the transalation. This will help you to understand the situation/context.`,
            ex: [],
        },
    ];

    // ---------------------------------------------------------------
    // Hooks

    public created() {
        this.loadData();
    }


    // ---------------------------------------------------------------
    // Actions

    public onAddRow() {
        this.editTranslations.push({
            key: '',
            value: '',
        });
    }

    public onDeleteRow(keyIndex: number) {
        this.editTranslations.splice(keyIndex, 1);
    }

    public onSearchItem() {
        const searchTerms = this.searchTerms;
        const translationList = { ...this.translationList };
        const filteredList: any = {};
        Object.keys(translationList).forEach((item) => {
            if ((translationList[item]).toLocaleLowerCase().startsWith(searchTerms.toLocaleLowerCase()) ||
                item.toLocaleLowerCase().startsWith(searchTerms.toLocaleLowerCase())) {
                filteredList[item] = translationList[item];
            }
        });
        this.filteredList = filteredList;
    }

    public onEditKeys(keyName: any) {
        const filteredList = this.filteredList;
        const editTranslations = this.editTranslations;
        const hasKeyName = editTranslations.find((item: any) => item.key === keyName);
        if (!hasKeyName) {
            const editObj = {
                key: keyName,
                value: filteredList[keyName],
            };
            this.editTranslations.push(editObj);
        }
    }

    public onUpdateTransations() {
        this.updateData();
    }

    public onChangeLang(value: any) {
        this.selectedLang = value;
        this.loadData();
    }

    public onUploadFile(event: any) {
        this.readCSVFile(event);
    }

    // ---------------------------------------------------------------
    // Methods

    public loadData(isRefresh?: any) {
        this.isLoading = true;
        const params: any = {
            language: this.selectedLang.id,
        };
        if (isRefresh) {
            params.refresh = true;
        }
        translationsAPI.fetchTranslationLabels(params).then((translationList) => {
            this.translationList = translationList;
            this.filteredList = { ...translationList };
            this.isLoading = false;
            this.jsonKeysList = Object.keys(translationList).map((itemKey) => {
                return {
                    key: itemKey,
                    value: translationList[itemKey],
                };
            });
        });
    }

    public async updateData() {
        const requestPayload = this.buildPayload();
        const appId = appConfigService.getAppId();
        const selectedLang = this.selectedLang;
        const session: any = sessionService.getSession();
        const tenantId = session.tenant!.tenant_id;
        const params = {
            appId,
            config: requestPayload,
            language: selectedLang.langCode,
            tenantId,
        };
        Promise.resolve().then(() => {
            this.editTranslations = [];
        });
        await translationsAPI.updateTranslationLabels(params);
        this.loadData(true);

    }

    public buildPayload() {
        const requestPayload: any = {};
        const editTranslations = this.editTranslations;
        editTranslations.forEach((item: any) => {
            if (item.value && item.key) {
                requestPayload[item.key] = item.value;
            }
        });
        return requestPayload;
    }

    public async readCSVFile(file: any) {
        const fileReader = new FileReader();
        fileReader.readAsText(file);
        const translationObj: any = [];
        this.isLoading = true;
        fileReader.onload = async (event) => {
            const csvData: any = event.target!.result;
            const jsonData = await papaparse.parse(csvData).data;
            jsonData.shift();
            for await (const item of jsonData) {
                translationObj.push({
                    key: item[0],
                    value: item[1],
                });
            }
            this.isLoading = false;
            this.editTranslations = translationObj;
        };
    }

    private showGuideLines() {
        this.$bvModal.show('translation-guidelines');
    }

}
